import { zipurl, unzipurl } from "zipurl";

/**
 * onepage中用于压缩、解压缩url的方法
 */
export { zipurl, unzipurl };

/**
 * 获取完整url的方法
 * @returns
 */
export const getUrl = () => {
  const url = window.location.href;
  return url;
};

/**
 * 从url中获取path部分
 * @returns
 */
export const getPath = () => {
  const path = window.location.pathname;
  return path;
};

/**
 * 获取有效的页面path
 * 忽略掉最后的 /result /update /detail /
 * @param {string} path 路径, 如果传入则使用传入的路径, 否则使用当前路径
 */
export const getEffectivePagePath = (path?: string) => {
  path = path || getPath();
  return path.replace(/\/(?:result|update|detail)?\/?$/g, "");
};

/**
 * 获取去除通配符后的页面真实路径
 * @param path useLocation().pathname 获取到的内容
 * @param splats useParams().* 获取到的内容（没有前缀 / ）
 * @returns
 */
export const getPathWithoutSplats = (path: string, splats: string = "") => {
  splats = `/${splats}`;
  return path.endsWith(splats) ? path.slice(0, -splats.length) : path;
};

/**
 * 从url中获取search部分
 * @param {string} key
 * @returns
 */
export const getSearchParams = (key) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (!key) {
    return searchParams;
  }
  return searchParams.get(key);
};

/**
 * 将url中的search对象转换成key-value对象
 */
export const getAllSearchParams = (search) => {
  const searchParams = new URLSearchParams(search || window.location.search);
  const params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
};

// export const getParams = () => {
//   const url = getUrl();
//   const urlArr = url.split("?");
//   const params = urlArr[1].split("&");
//   const paramsObj = {};
//   params.forEach((item) => {
//     const param = item.split("=");
//     paramsObj[param[0]] = param[1];
//   });
//   return paramsObj;
// };

/**
 * 解析hash中的参数, 格式和url中相同#key1=aa&key2=bb
 * @param {string} key
 * @returns
 */
export const getHashParams = (key) => {
  const matches = window.location?.hash?.match(
    new RegExp(`[#&]${key}=([^&]*)`),
  );
  return key && matches ? matches[1] : null;
};

/**
 * 从url中获取ui控制相关的config
 */
export const getUiConfig = () => {
  const uiHideNav = getSearchParams("ui_hide_nav"); // url参数控制是否需要隐藏顶部导航
  const uiHideMenu = getSearchParams("ui_hide_menu"); // url参数控制是否需要隐藏左侧菜单
  return {
    uiHideNav: uiHideNav === "true" ? true : false,
    uiHideMenu: uiHideMenu === "true" ? true : false,
  };
};

/**
 * 从url中判断是否是预览模式
 * @returns
 */
export const isPreview = () => {
  return getSearchParams("preview") === "true";
};
